import { config } from '@/pageConfig/faq/us/en';
import { FaqPageTemplate } from '@/pageTemplate/FaqPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function FaqPage() {
  const { trackEvent } = useAnalyticsContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: we just one it on load so no need to add it as a dependency
  useEffect(() => {
    trackEvent('faq_page.viewed');
  }, []);

  return <FaqPageTemplate config={config} locale="en-US" />;
}
